<template>
    <div class="container mt-nav z-index">
        <Head title="ثبت بیماری ها" />
        <div class="row">
            <div class="col-sm-10 col-lg-8  mx-auto">
                <div class="box__checked">
                    <p class="text-title text-white text-center line-height pb-3">اگر بیماری خاصی دارید در قسمت زیر انتخاب
                        کنید</p>
                    <form action="">
                        <div  class="scroll__box">
                            <div class="check__box mt-5  px-4">
                                <template v-for="category in diseaseCategory">
                                    <div class="d-flex align-content-center my-2 title__checked">
                                        <p class="m-0 text-orange text-md white-space">{{category.title}}</p>
                                        <span class="border-title"></span>
                                    </div>
                                    <div class="d-flex align-content-center flex-wrap">
                                        <template v-for="disease in diseases">
                                            <template v-if="disease.parent_id == category.id">
                                                <label :for="'check_box' + disease.id" class="my-4 mx-2">
                                                    <input class="checkbox__sickness" name="sickness" :id="'check_box' + disease.id" type="checkbox">
                                                    <span class="text-md m-0 text-white style_checkbox">{{disease.title}}</span>
                                                </label>
                                            </template>
                                        </template>

                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="text-center mt-5">

                            <button class="btn btn-orange hide-box w-100-btn">خرید و سفارش</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {Head, Link} from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "..//Shared/Layouts/LayoutFirstRegister";

export default {
    props : ['diseases' , 'diseaseCategory'],
    components: {
        Head, Link
    },

    layout: LayoutFirstRegister,
    metaInfo() {
        return {
            meta : [
            ]
        }
    }
}
</script>

<style scoped>

</style>
